// extracted by mini-css-extract-plugin
export default {"rating":"iKwNb6","star":"pOWEPk","star__icon":"JqD01w","on":"LZm5Kq","hover":"xFcQkh","active":"LQH3mu"};